import React from 'react';
import { noTagLabel } from '../../lib/assets';

/** The tag in mono type; a device without one shows a Personal / No tag yet chip in its place. */
export default function TagChip({ asset, className = 'as-tag' }) {
  if (asset?.asset_tag) return <span className={className}>{asset.asset_tag}</span>;
  return (
    <span className="as-chip" data-tone={asset?.is_personal ? 'info' : 'idle'} data-testid="no-tag-chip">
      {noTagLabel(asset)}
    </span>
  );
}
